export default {
  length: {
    '915': '3',
    '1220': '4',
    '1830': '6',
    '2134': '7',
    '2439': 'PET\n96',
    '2440': '8',
    '2658': 'PET\n104-5/8',
    '2963': 'PET\n116-5/8',
    '3050': '10',
    '3660': '12',
    '4268': '14',
    '4880': '16',
    '5487': '18',
    '6096': '20'
  },
  thickness: {
    '19': "1",
    '24.5': "1 full",
    '29': "5/4",
    '32': "5/4",
    '38': "2",
    '89': "4"
  },
  width: {
    '38': "2",
    '64': "3",
    '89': "4",
    '114': "5",
    '140': "6",
    '165': "7",
    '184': "8",
    '235': "10",
    '286': "12"
  },
  quality: {
    'AB': "PREMIUM \n #2&BTR",
    'I-III r.': "PREMIUM \n #2&BTR",
    'I-III r. BS': "PREMIUM \n #2&BTR",
    'I-III r. W': "PREMIUM \n #2&BTR",
    'IV r.': "#3&btr"
  },
  profile: {
    'P': 'S4S SE',
    'SK': 'S4S SE',
    'PB': 'S4S EE',
    'TG':	'S4S EE',
    'TGU':	'T&G',
    'ST-M':	'WP4',
    'ST-O':	'WP4-E&CB'
  },
  wood: {
    'Egle': "SP",
    'Pusis': "SP",
    'Maumedis': "Larch",
    'Pusis/Egle': "SP",
    'mixsas': "Mix",
    'Berzas': "Birch",
  },
  humidity: {
    '18': "KDHT"
  }
}


// WEBPACK FOOTER //
// ./src/helpers/pdf-labels/olympic-mapper.js